import { useState, KeyboardEvent, useEffect } from 'react';
import { IconButton, TextField, TextFieldProps } from '@mui/material';
import { ClearIcon } from '@mui/x-date-pickers';

import SearchIcon from '../icons/SearchIcon';
import { colors } from 'theme/mui/colors';
import { DEBOUNCE_TIME } from 'constants/server/apiSettings';
import { useDebounce } from 'hooks/general/useDebounce';

interface Props extends Omit<TextFieldProps, 'onChange' | 'value'> {
  onSearch: (value: string) => void;
  debouncedTime?: number;
  defaultValue?: string;
}

const InputSearch = (props: Props) => {
  const { onSearch, debouncedTime = DEBOUNCE_TIME, defaultValue, ...textFieldProps } = props;
  const [text, setText] = useState(defaultValue || '');

  const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      onSearch(text);
    }
  };
  const debouncedSearch = useDebounce(text, debouncedTime);

  useEffect(() => {
    onSearch(debouncedSearch);
  }, [debouncedSearch, onSearch]);

  return (
    <TextField
      value={text}
      onChange={e => setText(e.target.value)}
      onKeyDown={handleKeyDown}
      placeholder="Search..."
      variant="outlined"
      size="medium"
      fullWidth
      slotProps={{
        input: {
          startAdornment: <SearchIcon color={colors.base.level60} style={{ marginRight: '0.5rem' }} width={16} />,
          endAdornment: text && (
            <IconButton size="small" onClick={() => setText('')}>
              <ClearIcon fontSize="small" />
            </IconButton>
          ),
        },
      }}
      {...textFieldProps}
    />
  );
};
export default InputSearch;
